import EventEditContainer from './event_edit_container';

const EventEdit = EventEditContainer;

export default EventEdit;
